"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visa = void 0;
var React = __importStar(require("react"));
var Visa = function () {
    return (React.createElement("svg", { width: 36, height: 27, viewBox: "0 0 36 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d_277_4968)" },
            React.createElement("g", { filter: "url(#filter1_d_277_4968)" },
                React.createElement("rect", { x: 1, y: 1, width: 34, height: 24, rx: 4, fill: "#1A1F71" })),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.75 16.858H9.69l-1.544-6.066c-.074-.279-.23-.525-.458-.642A6.573 6.573 0 005.8 9.51v-.234h3.318c.458 0 .801.35.859.758l.8 4.376 2.06-5.134h2.002l-3.089 7.583zm4.234 0h-1.945l1.602-7.583h1.945l-1.602 7.583zm4.118-5.482c.058-.409.401-.642.802-.642a3.535 3.535 0 011.888.35l.343-1.633a4.801 4.801 0 00-1.773-.35c-1.888 0-3.262 1.05-3.262 2.507 0 1.11.973 1.692 1.66 2.042.743.35 1.03.584.972.934 0 .524-.572.758-1.144.758a4.789 4.789 0 01-2.002-.467l-.344 1.634c.687.29 1.43.408 2.117.408 2.117.058 3.433-.992 3.433-2.567 0-1.983-2.69-2.1-2.69-2.974zm9.498 5.482l-1.545-7.583h-1.659a.863.863 0 00-.801.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108H29.6zm-2.918-5.54l.572 2.857h-1.602l1.03-2.858z", fill: "#fff" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_277_4968", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4968" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4968", result: "shape" })),
            React.createElement("filter", { id: "filter1_d_277_4968", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4968" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4968", result: "shape" })))));
};
exports.Visa = Visa;
